import React from "react";
import ErrorIcon from "../../../../static/images/error-icon.svg";

const ErrorMessage = ({
  error,
  className = "",
  imgClassNames = [],
  errorContainerClassName = "error__text",
}) => (
  <div className={`error ${className}`}>
    <span className="error__icon">
      <img
        src={ErrorIcon}
        alt="Error"
        className={imgClassNames.join(" ")}
      />
    </span>
    <div className={errorContainerClassName}>{error}</div>
  </div>
);

export default ErrorMessage;
